import { render, staticRenderFns } from "./AdminTenants.vue?vue&type=template&id=5373e915"
import script from "./AdminTenants.vue?vue&type=script&lang=ts"
export * from "./AdminTenants.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports